import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import {
  DateFormatMedium,
  DurationTimeLong,
  TimeFormatShort,
  TimeFormatWithTimezone,
} from '../../utils/dateFormatting';
import { FAIcon } from '../adapters/fontAwesomeAdapters';
import { DistanceFormat } from '../domainSpecific/measuringUnitsElements';
import { DistanceUnit } from '../../app/enums/measuringUnits';
import { useQuoteRoutingContentStyles } from './QuoteRoutingContent.styles';

export function DirectDriveIcon() {
  const { styles } = useQuoteRoutingContentStyles();
  return (
    <div className={styles.verticalCenter}>
      <div className={classNames(styles.valueLarge, styles.valueLargeFixedW)}>
        <div className={styles.flightInfo}>
          <FAIcon className={styles.directDriveIcon} icon="truck" />
          <FormattedMessage id="book.newQuote.directDrive" />
        </div>
      </div>
    </div>
  );
}

export function DeliveryTimeColumn({
  label,
  departure,
  departureTimezone,
  arrival,
  arrivalTimezone,
}) {
  const { styles } = useQuoteRoutingContentStyles();
  return (
    <div>
      <div className={styles.labelSmall}>
        <FormattedMessage id={label} />
      </div>
      <div className={styles.valueSmall}>
        <TimeFormatWithTimezone
          value={departure}
          timeZone={departureTimezone}
        />{' '}
        - <TimeFormatWithTimezone value={arrival} timeZone={arrivalTimezone} />
      </div>
      <div className={styles.labelSmall}>
        <DateFormatMedium value={departure} />
      </div>
    </div>
  );
}

export function DeliveryDurationColumn({ label, duration }) {
  const { styles } = useQuoteRoutingContentStyles();
  return (
    <div>
      <div className={styles.labelSmall}>
        <FormattedMessage id={label} />
      </div>
      <div className={styles.valueSmall}>
        <DurationTimeLong value={duration} />
      </div>
    </div>
  );
}

export function TentativeDeliveryColumn({ deliveryDateTime }) {
  const { styles } = useQuoteRoutingContentStyles();
  return (
    <div>
      <div className={styles.labelSmall}>
        <FormattedMessage id="book.newQuote.tentativeDelivery" />
      </div>
      {deliveryDateTime && (
        <>
          <div className={styles.valueSmall}>
            <TimeFormatShort value={deliveryDateTime} />
          </div>
          <div className={styles.labelSmall}>
            <DateFormatMedium value={deliveryDateTime} />
          </div>
        </>
      )}
    </div>
  );
}

export function DriveTypeColumn({ type }) {
  const { styles } = useQuoteRoutingContentStyles();
  return (
    <div>
      <div className={styles.labelSmall}>
        <FormattedMessage id="book.newQuote.driveType" />
      </div>
      <div className={styles.valueSmall}>
        {type || <FormattedMessage id="vehicle.car" />}
      </div>
    </div>
  );
}

export function DriveMileageColumn({ distance }) {
  const { styles } = useQuoteRoutingContentStyles();
  return (
    <div>
      <div className={styles.labelSmall}>
        <FormattedMessage id="book.newQuote.mileage" />
      </div>
      <div className={styles.valueSmall}>
        <DistanceFormat
          value={distance}
          inputUnit={DistanceUnit.MILES}
          unit={DistanceUnit.MILES}
        />
      </div>
    </div>
  );
}
